import { Settings2 } from "@tamagui/lucide-icons";
import type React from "react";

import type { ModalProps } from "react-native";
import { XStack, YStack } from "tamagui";
import { Button } from "../../../ui/Button";
import { Modal } from "../../../ui/Modal";
import { TipsText } from "../../../ui/TipsText";
import { Title } from "../../../ui/Title";
import type TrackerModuleModel from "../TrackerModuleModel";
import { TrackerHistoryList } from "./TrackerHistoryList";

export const TrackerHistoryListModal: React.FC<
  {
    module: TrackerModuleModel;
    userUid: string;
    onClose: () => void;
  } & ModalProps
> = ({ module, visible, userUid, onClose }) => {
  const userData = module.getUserData(userUid);

  return (
    <Modal
      modalId="tracker_history"
      onClose={onClose}
      visible={visible}
      header={
        <YStack gap="$medium">
          <XStack gap="$medium" alignItems="center">
            <Settings2 />
            <Title>Activity ({userData?.data.history.length ?? 0})</Title>
          </XStack>
          <TipsText
            text={`The latest and greatest from ${
              userData?.user?.data.displayName ?? "-"
            }`}
          />
        </YStack>
      }
      footer={
        <YStack gap="$medium">
          <Button
            onPress={() => {
              onClose();
            }}
          >
            Close
          </Button>
        </YStack>
      }
    >
      <TrackerHistoryList
        module={module}
        history={userData?.data.history}
        showEdit={false}
      />
    </Modal>
  );
};
